import { initializeApp, getApps, getApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";
import { FIREBASE_CONFIG } from "./config";

let firebaseApp;
if (!getApps().length) {
    firebaseApp = initializeApp(FIREBASE_CONFIG);
} else {
    firebaseApp = getApp();
}

let analytics = null;
if (typeof window !== "undefined") {
    try {
        analytics = getAnalytics(firebaseApp);
    } catch (error) {
        console.error("Firebase Analytics initialization error:", error);
    }
}

export default firebaseApp;

// For messaging
export const getFirebaseMessaging = async () => {
    // The isSupported() check ensures the browser supports FCM.
    const supported = await isSupported();
    if (!supported) return null;

    return getMessaging(firebaseApp);
};

// For analytics
export const getFirebaseAnalytics = () => {
    return analytics;
};
